import { NOT_ASSIGNED } from 'constants/constants';
import styled from 'styled-components';
import { FieldPanelHeader } from 'styles/v2/Styles.styled';
import { DataQualityAssessmentReadModel } from 'types/types';
import { isArraySingleEmptyValue } from 'util/utils';
import usePcrV2 from '../../hooks/usePcrV2';
import VersionHistorySummaryGrid, { SummaryGridRow } from '../VersionHistorySummaryGrid';
import { ComparerRowsGetter } from '../../version-compare/VersionCompareKeyValueGrid';
import { EpdVersionHistoryData } from '../utils/EpdVersionHistoryDataContext';

const VersionHistoryDataQualityAssessment: React.FC<{
  data: EpdVersionHistoryData;
}> = ({ data }) => {
  const isPcrV2 = usePcrV2();
  const isOnlySingleEmptyRow =
    data?.dataQualityAssessmentAndReferenceYears?.dataQualityAssessmentItems &&
    isArraySingleEmptyValue(data?.dataQualityAssessmentAndReferenceYears.dataQualityAssessmentItems);

  const anyRows =
    data?.dataQualityAssessmentAndReferenceYears?.dataQualityAssessmentItems &&
    data?.dataQualityAssessmentAndReferenceYears.dataQualityAssessmentItems.length > 0 &&
    !isOnlySingleEmptyRow;

  const summaryExists =
    !!data?.dataQualityAssessmentAndReferenceYears?.dataQualityAssessmentSummary &&
    (!!data?.dataQualityAssessmentAndReferenceYears.dataQualityAssessmentSummary?.dataQualityAssessmentSummary ||
      !!data?.dataQualityAssessmentAndReferenceYears.dataQualityAssessmentSummary.dataQualityAssessmentComment);

  if (!anyRows && !summaryExists) {
    return null;
  }

  const summaryRow = getDataQualityAssessmentSummaryRow(data, isPcrV2);

  return (
    <>
      <StyledFieldPanelHeader>
        {isPcrV2 ? 'Data quality assessment' : 'Data quality assessment and reference years'}
      </StyledFieldPanelHeader>
      {summaryRow.length > 0 && (
        <ContentWrapper>
          <VersionHistorySummaryGrid rows={summaryRow} />
        </ContentWrapper>
      )}
    </>
  );
};

export const getDataQualityAssessmentSummaryRow: ComparerRowsGetter = (
  data: EpdVersionHistoryData,
  _: boolean,
  __: any
): SummaryGridRow[] => {
  const summaryRow: SummaryGridRow[] = [];
  if (data?.dataQualityAssessmentAndReferenceYears?.dataQualityAssessmentSummary?.dataQualityAssessmentSummary) {
    summaryRow.push({
      name: 'Description of data quality assessment and reference years',
      value:
        data?.dataQualityAssessmentAndReferenceYears?.dataQualityAssessmentSummary?.dataQualityAssessmentSummary ??
        NOT_ASSIGNED,
    });
  }
  return summaryRow;
};

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const StyledFieldPanelHeader = styled(FieldPanelHeader)`
  gap: 20px;
`;

export default VersionHistoryDataQualityAssessment;
